/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { TeamModelDto } from '../models/team-model-dto';
import { userControllerCreateTeam } from '../fn/user/user-controller-create-team';
import { UserControllerCreateTeam$Params } from '../fn/user/user-controller-create-team';
import { userControllerDeleteTeam } from '../fn/user/user-controller-delete-team';
import { UserControllerDeleteTeam$Params } from '../fn/user/user-controller-delete-team';
import { userControllerGetMe } from '../fn/user/user-controller-get-me';
import { UserControllerGetMe$Params } from '../fn/user/user-controller-get-me';
import { userControllerGetTeams } from '../fn/user/user-controller-get-teams';
import { UserControllerGetTeams$Params } from '../fn/user/user-controller-get-teams';
import { userControllerUpdateMe } from '../fn/user/user-controller-update-me';
import { UserControllerUpdateMe$Params } from '../fn/user/user-controller-update-me';
import { userControllerUpdateTeam } from '../fn/user/user-controller-update-team';
import { UserControllerUpdateTeam$Params } from '../fn/user/user-controller-update-team';
import { UserModelDto } from '../models/user-model-dto';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerGetMe()` */
  static readonly UserControllerGetMePath = '/user/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMe$Response(params?: UserControllerGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return userControllerGetMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMe(params?: UserControllerGetMe$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.userControllerGetMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateMe()` */
  static readonly UserControllerUpdateMePath = '/user/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUpdateMe$Response(params: UserControllerUpdateMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return userControllerUpdateMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUpdateMe(params: UserControllerUpdateMe$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.userControllerUpdateMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

  /** Path part for operation `userControllerGetTeams()` */
  static readonly UserControllerGetTeamsPath = '/user/teams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetTeams()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetTeams$Response(params?: UserControllerGetTeams$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamModelDto>>> {
    return userControllerGetTeams(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetTeams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetTeams(params?: UserControllerGetTeams$Params, context?: HttpContext): Observable<Array<TeamModelDto>> {
    return this.userControllerGetTeams$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TeamModelDto>>): Array<TeamModelDto> => r.body)
    );
  }

  /** Path part for operation `userControllerCreateTeam()` */
  static readonly UserControllerCreateTeamPath = '/user/teams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCreateTeam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreateTeam$Response(params: UserControllerCreateTeam$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelDto>> {
    return userControllerCreateTeam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCreateTeam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreateTeam(params: UserControllerCreateTeam$Params, context?: HttpContext): Observable<TeamModelDto> {
    return this.userControllerCreateTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelDto>): TeamModelDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateTeam()` */
  static readonly UserControllerUpdateTeamPath = '/user/teams/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateTeam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateTeam$Response(params: UserControllerUpdateTeam$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelDto>> {
    return userControllerUpdateTeam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateTeam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdateTeam(params: UserControllerUpdateTeam$Params, context?: HttpContext): Observable<TeamModelDto> {
    return this.userControllerUpdateTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelDto>): TeamModelDto => r.body)
    );
  }

  /** Path part for operation `userControllerDeleteTeam()` */
  static readonly UserControllerDeleteTeamPath = '/user/teams/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerDeleteTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDeleteTeam$Response(params: UserControllerDeleteTeam$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userControllerDeleteTeam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerDeleteTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerDeleteTeam(params: UserControllerDeleteTeam$Params, context?: HttpContext): Observable<void> {
    return this.userControllerDeleteTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
